import { ok } from '@nanovnaweb/shared';
import { useStore as useZustandStore } from 'zustand';
import { createStore } from 'zustand/vanilla';
function splitByOrigin(traces) {
    const recorded = [];
    const imported = [];
    for (const t of traces) {
        if (t.driverKind !== undefined)
            recorded.push(t);
        else
            imported.push(t);
    }
    return { recorded, imported };
}
export function createTraceStore(deps) {
    const store = createStore()(() => ({
        recorded: [],
        imported: [],
        loading: false,
        lastError: null,
    }));
    const actions = {
        async hydrate() {
            store.setState({ loading: true });
            const r = await deps.traceRepo.listAll();
            if (r.kind === 'err') {
                store.setState({ loading: false, lastError: r.error });
                return r;
            }
            const split = splitByOrigin(r.value);
            store.setState({
                recorded: Object.freeze([...split.recorded]),
                imported: Object.freeze([...split.imported]),
                loading: false,
                lastError: null,
            });
            return ok(undefined);
        },
        async saveRecording(trace) {
            const r = await deps.traceRepo.save(trace);
            if (r.kind === 'err') {
                store.setState({ lastError: r.error });
                return r;
            }
            const state = store.getState();
            const updated = trace.driverKind !== undefined
                ? {
                    recorded: Object.freeze([...state.recorded, trace]),
                    imported: state.imported,
                }
                : {
                    recorded: state.recorded,
                    imported: Object.freeze([...state.imported, trace]),
                };
            store.setState({ ...updated, lastError: null });
            return ok(undefined);
        },
        async importTouchstone(blob, opts) {
            const r = await deps.traceRepo.importTouchstone(blob, opts);
            if (r.kind === 'err') {
                store.setState({ lastError: r.error });
                return r;
            }
            const state = store.getState();
            store.setState({
                imported: Object.freeze([...state.imported, r.value.trace]),
                lastError: null,
            });
            return ok(r.value.trace);
        },
        async exportTouchstone(id) {
            const r = await deps.traceRepo.exportTouchstone(id);
            if (r.kind === 'err') {
                store.setState({ lastError: r.error });
            }
            return r;
        },
        async delete(id) {
            const r = await deps.traceRepo.delete(id);
            if (r.kind === 'err') {
                store.setState({ lastError: r.error });
                return r;
            }
            const state = store.getState();
            store.setState({
                recorded: Object.freeze(state.recorded.filter((t) => t.id !== id)),
                imported: Object.freeze(state.imported.filter((t) => t.id !== id)),
            });
            return ok(undefined);
        },
        async clear() {
            const r = await deps.traceRepo.clear();
            if (r.kind === 'err') {
                store.setState({ lastError: r.error });
                return r;
            }
            store.setState({ recorded: Object.freeze([]), imported: Object.freeze([]) });
            return ok(undefined);
        },
    };
    return { store, actions };
}
export function useTraceStore(store, selector) {
    return useZustandStore(store, selector);
}
//# sourceMappingURL=trace-store.js.map